import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { toggleSideBar } from '@greenkub-fronts/domain/ui';
import { authActions } from '@greenkub-fronts/domain/auth';
import {
  AppDispatch,
  RootState,
  UiTheme,
} from '@greenkub-fronts/shared/interface';
import { useWindowDimensions } from '@greenkub-fronts/shared/utils';

import styles from './menu.module.scss';
import { logo_square } from '../../../assets';
import { IconEnum } from '../../icon/icon.enum';
import Icon from '../../icon/icon';

export interface MenuProps {
  children: React.ReactElement;
}

export const Menu = (props: MenuProps) => {
  const { children } = props;

  const dispatch = useDispatch<AppDispatch>();

  const { currentTheme } = useSelector((state: RootState) => state.ui);
  const { sideBarIsOpen } = useSelector((state: RootState) => state.ui);

  const { windowWidth } = useWindowDimensions();

  return (
    <div
      className={cx(
        styles['Menu-wrapper'],
        styles[currentTheme],
        sideBarIsOpen && currentTheme !== UiTheme.GEKA
          ? styles['sidebarIsOpen']
          : styles['sidebarIsClosed']
      )}
    >
      <nav
        className={cx(
          styles['Menu'],
          sideBarIsOpen && currentTheme !== UiTheme.GEKA
            ? styles['sidebarIsOpen']
            : styles['sidebarIsClosed']
        )}
      >
        <div className={styles['Menu-head']}>
          <Link to="/">
            {currentTheme === UiTheme.GEKA ? (
              <Icon
                name={IconEnum.GEKA_LOGO_GREEN_NO_BG}
                className={cx(styles['Menu-logo'], styles['Logo-Geka'])}
                width="200"
              />
            ) : windowWidth <= 767 ? (
              <img
                className={cx(
                  styles['Menu-logo'],
                  styles['Menu-logo-small'],
                  'mt20'
                )}
                src={logo_square}
                alt="Logo Greenkub"
              />
            ) : (
              <Icon
                name={IconEnum.LOGO}
                width="220"
                className={cx(styles['Menu-logo'], styles['Menu-logo-big'])}
              />
            )}
          </Link>
          {/* ICONE DE FERMETURE */}

          {currentTheme !== UiTheme.GEKA &&
            (windowWidth > 767 ? (
              <Icon
                className={styles['Menu-toggleClose']}
                onClick={() => dispatch(toggleSideBar())}
                name={IconEnum.ARROW_BACK_IOS}
              />
            ) : (
              <Icon
                className={styles['Menu-toggleCloseMobile']}
                onClick={() => dispatch(toggleSideBar())}
                name={IconEnum.CLOSE}
              />
            ))}
        </div>

        {/* Bloc menu déroulant */}
        {/* <div className={styles['Menu-profile']}>
          <div className={styles['Menu-profile-avatar']}>
            {user.avatar ? (
              <img
                className={styles['Menu-avatar']}
                src={user.avatar}
                alt="Avatar profil"
              />
            ) : (
              <Icon name={IconEnum.ACCOUNT} />
            )}
          </div>
          <div className={styles['Menu-profile-infos']}>
            <span className={styles['Menu-profile-name']}>
              {user.firstName + ' ' + user.lastName}
            </span>
            <span className={styles['Menu-profile-email']}>{user.email}</span>
          </div>
        </div> */}

        <div className={styles['Menu-body']}>
          <ul className={styles['Menu-content']}>
            {children}

            <li className={cx(styles['Menu-item'], styles['Deconnection'])}>
              <Icon name={IconEnum.DECONNEXION} />
              <span onClick={() => dispatch(authActions.logout())}>
                Déconnexion
              </span>
            </li>
          </ul>

          <div id="menu-portal" />
        </div>
      </nav>
    </div>
  );
};

export default Menu;
